// Asset imports for the unified app
// This file makes it easier to import assets from components

// Logos
import itzLogo from './logos/itz-logo.png';
import reactLogo192 from './logos/react-logo-192.png';
import reactLogo512 from './logos/react-logo-512.png';

// Avatars
import studentDog from './avatars/student-dog.png';
import teacherAvatar from './avatars/teacher-avatar.jpg';
import teacherAvatarPng from './avatars/teacher-avatar.png';
import teacherMamaPanda from './avatars/teacher-mama-panda.jpeg';
import teacherJpg from './avatars/teacher.jpg';
import teacherPng from './avatars/teacher.png';
import owlTeacher from './avatars/Owl_Teacher.jpg';
import parentAvatar from './avatars/Parent.png';

// Backgrounds
import readingSessionImage from './backgrounds/reading-session-image.png';

// Icons
import favicon from './icons/favicon.ico';

export {
  // Logos
  itzLogo,
  reactLogo192,
  reactLogo512,
  
  // Avatars
  studentDog,
  teacherAvatar,
  teacherAvatarPng,
  teacherMamaPanda,
  teacherJpg,
  teacherPng,
  owlTeacher,
  parentAvatar,
  
  // Backgrounds
  readingSessionImage,
  
  // Icons
  favicon
};

// Default export with organized structure
export default {
  logos: {
    itz: itzLogo,
    react192: reactLogo192,
    react512: reactLogo512
  },
  avatars: {
    studentDog,
    teacherAvatar,
    teacherAvatarPng,
    teacherMamaPanda,
    teacherJpg,
    teacherPng,
    owlTeacher,
    parentAvatar
  },
  backgrounds: {
    readingSession: readingSessionImage
  },
  icons: {
    favicon
  }
};